import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import TabNavigation from '../../../components/organisms/tab-navigation';
import { useEffect } from 'react';

const PortManagement = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();

	const options: { label: string; path: string }[] = [
		{
			label: t('port_management.return.title'),
			path: '/port_management/return',
		},
		{
			label: t('port_management.travels.title'),
			path: '/port_management/travels',
		},
		{
			label: t('port_management.ships.title'),
			path: '/port_management/ships',
		},
		{
			label: t('port_management.monitoring.title'),
			path: '/port_management/monitoring',
		},
		{
			label: t('port_management.carriers.title'),
			path: '/port_management/carriers',
		},
		{
			label: t('port_management.materials.title'),
			path: '/port_management/materials',
		},
		{
			label: t('port_management.containers.title'),
			path: '/port_management/containers',
		},
		{
			label: t('port_management.maintenance.title'),
			path: '/port_management/maintenance',
		},
		{
			label: t('port_management.energy_cost.title'),
			path: '/port_management/energy_cost',
		},
	];

	useEffect(() => {
		if (location.pathname.split('/').length <= 2) navigate(options[0].path);
	}, [location]);

	return (
		<div className="flex flex-col flex-grow bg-white rounded-lg shadow-md">
			<TabNavigation options={options} />
			<Outlet />
		</div>
	);
};

export default PortManagement;
